const normalizeKey = (value) => String(value || "").trim().toLowerCase();
const DEPRECATED_VISUAL_STYLE_KEYS = new Set([
  "3d_xianxia",
  "3d_gaowu",
  "3d_modern",
  "3d_urban",
  "3d_realistic",
  "3d_game_cg",
  "unity",
  "ldr",
  "comic_storyboard",
  "line_art",
  "marvel",
  "junji_ito",
]);
const LEGACY_VISUAL_STYLE_ALIASES = {
  "3d_xianxia": "chinese_3d_donghua",
  "3d_gaowu": "chinese_3d_donghua",
  "3d_modern": "chinese_3d_donghua",
  "3d_urban": "chinese_3d_donghua",
  "3d_realistic": "chinese_3d_donghua",
  "3d_game_cg": "chinese_3d_donghua",
};

export const normalizeVisualStyleKey = (value, fallback = "modern_cdrama") => {
  const key = normalizeKey(value);
  if (!key) return fallback;
  if (LEGACY_VISUAL_STYLE_ALIASES[key]) return LEGACY_VISUAL_STYLE_ALIASES[key];
  if (DEPRECATED_VISUAL_STYLE_KEYS.has(key)) return fallback;
  return key;
};

export const getVisualReferenceMediaUrl = (item) => (
  item?.thumbnailUrl
  || item?.referenceUrl
  || item?.previewVideoUrl
  || ""
);

export const attachVisualStyleReferences = (styleOptions = [], references = []) => {
  const byKey = new Map();

  (references || []).forEach((item) => {
    const key = normalizeKey(item?.itemKey);
    if (DEPRECATED_VISUAL_STYLE_KEYS.has(key)) return;
    const mediaUrl = getVisualReferenceMediaUrl(item);
    if (!key || !mediaUrl) return;
    byKey.set(key, item);
  });

  const knownKeys = new Set();
  const merged = (styleOptions || []).map((option) => {
    const key = normalizeKey(option?.value);
    if (key) knownKeys.add(key);
    const ref = byKey.get(normalizeKey(option?.value));
    const mediaUrl = getVisualReferenceMediaUrl(ref);
    return {
      ...option,
      label: ref?.name || option?.label,
      referenceItem: ref || null,
      referenceImageUrl: mediaUrl,
    };
  });

  (references || []).forEach((item) => {
    const key = normalizeKey(item?.itemKey);
    if (DEPRECATED_VISUAL_STYLE_KEYS.has(key)) return;
    const mediaUrl = getVisualReferenceMediaUrl(item);
    if (!key || !mediaUrl || knownKeys.has(key)) return;
    knownKeys.add(key);
    merged.push({
      value: item.itemKey,
      label: item.name || item.nameEn || item.itemKey,
      description: item.summary || item.usageScene || "",
      referenceItem: item,
      referenceImageUrl: mediaUrl,
      isAdminStyle: true,
    });
  });

  return merged;
};
